import { getAccountName, parseHeadcount, parseRevenueUsd } from './utils'

/** Columns of the custom-search results table. Skeleton cells follow the same alignment. */
// Fixed widths (with tableLayout 'fixed') keep each cell to one line: short values like
// "11-50 employees" fit, longer ones end in "…" and show in full on hover.
// Click a header to sort; sortValue gives each computed cell a comparable value (empty last).
export const RESULT_COLUMNS = [
    { name: 'Name', uid: 'company_name', align: 'left' as const, width: '26%', sortable: true, sortValue: (a: any) => getAccountName(a) || null },
    { name: 'Industry', uid: 'industry', align: 'left' as const, width: '20%', sortable: true, sortValue: (a: any) => a?.industry || null },
    { name: 'Employee Size', uid: 'employee_size', align: 'left' as const, width: '14%', sortable: true, sortValue: (a: any) => parseHeadcount(a?.company_size || a?.headcount) },
    { name: 'Revenue', uid: 'revenue', align: 'left' as const, width: '14%', sortable: true, sortValue: (a: any) => parseRevenueUsd(a?.revenue || a?.annual_revenue) },
    { name: 'Location', uid: 'location', align: 'left' as const, width: '18%', sortable: true, sortValue: (a: any) => a?.location || null },
    { name: 'Actions', uid: 'actions', align: 'center' as const, width: '8%' },
];

export const SKELETON_ROWS = Array.from({ length: 9 }).map((_, i) => ({
    id: `skeleton-${i}`,
    _isSkeleton: true,
}));

export const TABLE_PROPS = {
    rowsPerPage: 50,
    height: 'calc(100dvh - 277px)',
    tableLayout: 'fixed',
    fitToWidth: true,
    headerColor: 'bg-[#F7F9FA] dark:bg-gray-800',
    headerClassName: 'text-sm font-medium text-gray-900 dark:text-gray-300 dark:border-gray-800',
    headerLabelClassName: 'font-medium',
} as const;

export const DRAWER_WIDTH = 500;
